import React from 'react'
import {connect} from 'react-redux'
import {Dialog, LoadMore, Toast} from 'react-weui'
import { setEvent } from '../services'
import axios from 'axios'
import qr from 'qr-encode'
import {browserHistory} from 'react-router'
import { WKOwnDialog } from './wk'
import { storage } from '../utils'
import { prodConfig } from '../config'
import { isMobileWeChat } from '../core/env'


class RepayQRCodeDialog extends React.Component {
    constructor() {
        super()
        this.hide = this.hide.bind(this)
        this.show = this.show.bind(this)
        this.showHYF = this.showHYF.bind(this)
        this.state = {
            title: '',
            show: false,
            buttons: [{
                label: '关闭',
                onClick: this.hide,
            }],
            loading: true,
            qrcode: '',
            invoice_id: '',
        }
    }

    hide() {
        this.setState({show: false})
    }

    bindOuterPay(invoiceId, platform, userSign) {
        const data = new FormData()
        data.append('platform', platform)
        data.append('user_sign', userSign)
        axios.post(`/api/invoice/${invoiceId}/bind_outer_account`, data)
    }

    show(invoice_id, platform = '', user_sign = '') {
        this.setState({show: true})
        if (invoice_id !== this.state.invoice_id) {
            this.setState({invice_id: invoice_id, loading: true})
            const data = new FormData()
            data.append('invoice_id', invoice_id)
            axios.post('/api/pay/native_repay', data).then(response => {
                const repay_data = response.data
                if (repay_data.code !== 0) {
                    alert(repay_data.msg)
                    return false
                }
                // cps专栏：外部平台绑定荔枝账号订单关系
                if (platform && user_sign) {
                    this.bindOuterPay(repay_data.data.invoice_id, platform, user_sign)
                }
                this.setState({loading: false, qrcode: qr(repay_data.data.code_url)})
            })
        }
    }

    showHYF(title, code_url) {
        this.setState({show: true, loading: false, qrcode: qr(code_url), title: title})
    }

    render() {
        return <Dialog show={this.state.show} title={this.state.title || '扫码支付'} buttons={this.state.buttons}>
            {this.state.loading ?
                <LoadMore loading>正在加载二维码</LoadMore>
                :
                <div>
                    <img className="qrcode-img" src={this.state.qrcode} alt="qrcode"/>
                    <p style={{fontSize: '12px', marginTop: '10px'}}>支付成功后，请刷新页面</p>
                </div>
            }
        </Dialog>
    }
}

class Pay extends React.Component {
    state = {
        showTipDialog: false,
        // 退款中不能购买弹窗
        isShowRefundingDialog: false,
    };

    onHideTipDialog() {
        this.setState({showTipDialog: false});
    }

    bindOuterPay(invoiceId, platform, userSign) {
        const data = new FormData()
        data.append('platform', platform)
        data.append('user_sign', userSign)
        axios.post(`/api/invoice/${invoiceId}/bind_outer_account`, data)
    }

    userCancelCallback(cancel_url){
        let getNowDayNow =  new Date().toLocaleDateString();
        if(storage.getItem('cancelDayRecord')){
            var getUserCancelDay = storage.getItem('cancelDayRecord');
            if(getNowDayNow != getUserCancelDay){
                setEvent({ name: 'pay-cancel-pay' })
                //跳转到活动页 延时跳转 测试cnzz统计
                setTimeout(()=>{
                    location.assign(cancel_url)
                },500)
                storage.setItem('cancelDayRecord',getNowDayNow)
            }
        }else{
            storage.setItem('cancelDayRecord',getNowDayNow)
            setEvent({ name: 'pay-cancel-pay' })
            setTimeout(()=>{
                location.assign(cancel_url)
            },500)
        }
    }

    componentWillReceiveProps(nextProps) {
        let query = browserHistory.getCurrentLocation().query
        const {params, success, fail, cancel} = nextProps.pay
        const repay_dialog = this.refs.repay_dialog
        const {dispatch} = this.props

        let userAgent = navigator.userAgent.toLowerCase()
        // 支付宝,微博和qq登陆，走支付宝支付
        if (/alipay/.test(userAgent) || /weibo/.test(userAgent) || / qq\//.test(userAgent)) {
            if (this.props.pay.status !== nextProps.status && nextProps.pay.status === 'paying') {
                // 注意！！ params， 就是dispatch来的数据， 会覆盖掉url里的参数， 还有就是参数是从window.location.search 里读的， 对于IOS 必须特殊处理
                axios.get('/api/pay/alipay', {
                    params: Object.assign({}, query, params)
                }).then(response => {
                    var data = response.data

                    if (data.code === 0) {
                        dispatch({type: 'PAY_REPAY'});
                        window.location.href = data.params.pay_url;
                    } else {
                        // 限时免费支付和全额优惠券支付
                        if (data.code === -1) {
                            success && success()
                            return true
                        }
                        if (data.code !== 0) {
                            fail && fail(data)
                            dispatch({type: 'PAY_ERROR'})
                            this.context.page.showAlert(data.msg)
                            return false
                        }
                    }
                }).catch(error => {
                    this.context.page.showAlert('与服务器通讯异常,请联系客服')
                    dispatch({type: 'PAY_ERROR'})
                })
            }
        } else {
 
            const handler = response => {
                var data = response.data
                // 退款过程中购买的特例
                if (data.code === 4) {
                    dispatch({ type: 'PAY_REPAY' })
                    return this.setState({ isShowRefundingDialog: true })
                }
                // 拼团支付特殊处理
                if (params.product === 'pay_channel_groupbuy' && params.activity_id !== 0) {
                    if (data.code === 0) {
                        dispatch({ type: 'PAY_REPAY' })
                        if (isMobileWeChat) {
                            window.wx.chooseWXPay({
                                ...data.params,
                                success: success ? () => success(data) : e => e,
                                fail: fail ? () => fail(data) : e => e,
                            })
                        } else {
                            repay_dialog.show(data.invoice_id)
                        }
                    } else {
                        dispatch({ type: 'PAY_ERROR' })
                        fail && fail(data)
                    }
                    return
                }
                // 限时免费支付和全额优惠券支付
                if (data.code === -1) {
                    success && success(data)
                    return true
                }
                if (data.code !== 0) {
                    fail && fail(data)
                    dispatch({ type: 'PAY_ERROR' })
                    this.context.page.showAlert(data.msg)
                    return false
                }

                // 汇云付
                if (data.trade_platform == 'HUIYUN') {
                    console.log('[HUIYUN]:', data);
                    if (data.params.pay_url) {
                        if (window.platform !== 'weixin') {
                            // 微博用户调起支付宝客户端支付，后端支持类型：课程，专栏和VIP会员
                            if (/weibo/.test(navigator.userAgent.toLowerCase()) && ['pay_lecture', 'pay_channel', 'liveroom_vip'].indexOf(params.product) > -1) {
                                dispatch({ type: 'PAY_REPAY' });
                                window.location.href = data.params.pay_url;
                            } else {
                                repay_dialog.showHYF('请用手机支付宝扫码完成支付', data.params.pay_url);
                                dispatch({ type: 'PAY_REPAY' })
                            }
                        } else {
                            this.context.page.showConfirm("温馨提示", "支付成功后，点击“确定”刷新页面", () => {
                                location.reload();
                            });
                            window.location.href = data.params.pay_url;
                        }
                    }
                    return;
                }

                var wx_params = data.params
                var invoice_id = data.invoice_id
                wx_params['fail'] = res => {
                    console.log(res)
                    repay_dialog.show(invoice_id, params.platform, params.user_sign)
                }
                wx_params['cancel'] = res => {
                    // 除了自动支付以外，其他取消支付将跳转指定地址
                    if (data.cancel_url && !query.autopaying && !query.sp_auto_pay) {
                        //通过localstorage判断用户当天取消次数
                        this.userCancelCallback(data.cancel_url)
                    }
                    cancel && cancel()
                }
                wx_params['success'] = res => {
                    // cps专栏：外部平台绑定荔枝账号订单关系
                    if (params.platform && params.user_sign) {
                        this.bindOuterPay(invoice_id, params.platform, params.user_sign)
                    }
                    success && success(data)
                }
                dispatch({ type: 'PAY_REPAY' })
                if (window.wxReady && window.platform === 'weixin') {
                    window.wx.chooseWXPay(wx_params)
                } else {
                    wx_params['fail']()
                }
            }

            const normalPayProcess = () => {
                axios.get('/api/pay/wxpay', {
                    params: Object.assign({}, query, params) // 注意！！ params， 就是dispatch来的数据， 会覆盖掉url里的参数， 还有就是参数是从window.location.search 里读的， 对于IOS 必须特殊处理
                }).then(handler).catch(error => {
                    console.log(error)
                    this.context.page.showAlert('与服务器通讯异常,请联系客服')
                    dispatch({ type: 'PAY_ERROR' })
                })
            }

            if (this.props.pay.status !== nextProps.status && nextProps.pay.status === 'paying') {
                // 如果是专栏是 cps 专栏
                // const whiteList = [
                //     68224216, // 肖欢林
                //     46851102, // 陈纯铃
                //     46374733, //谢晓丽
                //     60412797, //郑丽华
                //     30335003, //欧阳文睿
                // ]
                // var id = parseInt(localStorage.lzwk_id) || null
                // && (id && whiteList.indexOf(id) >= 0)

                // 渠道号白名单
                // const nsidWhiteList = [
                //     'c_60436',
                //     'c_60385',
                //     'c_60799',
                //     'c_60687',
                //     'c_60688',
                //     'c_61186',
                //     'c_61172',
                //     'c_61172',
                //     'c_60949',
                //     'c_62040',
                //     'c_62363', 
                //     'c_62326',
                //     'c_62040',
                //     'c_62283',
                //     'c_62360'
                //     ]
                const channelWhiteList = [
                    '363188',
                    '390503',
                    '128226',
                    '431474',
                    // '466806',
                    // '363188',
                    // '390503',
                    '409738',
                    // '408333',
                    '334632',
                    '387839',
                    '361743',
                    '361708',
                    '478105',
                    '382276',
                    '442271',
                    '409262',
                    '229974',
                    '347907',
                    '378631',
                    '90120',
                    '212719',
                    '477557',
                    '293041',
                    // '171774',
                    '166836',
                    //新增的专栏id
                    '455080',
                    '94362',
                    '410437',
                    '487586',
                    '320857',
                    '456930',
                    '477856',
                    '404379',
                    '519938',
                    '374607',
                    '435845',
                    '456969',
                    '525285',
                    '251766',
                    '492037',
                    '492428',
                    '411564',
                    '513857',
                    '435806',
                    '417500',
                    '133054',
                    '72194',
                    '416656',
                    '522595',
                    '383476',
                    '392640',
                    '264826',
                    '529470',
                    '468300',
                    '545204',
                    '544785',
                    '538739',
                    '530397',
                    '499711',
                    '507190',
                    '403870',
                    '85952',
                    '426651',
                    '474162',
                    '410575',
                    '449223',
                    '105108',
                    '377232',
                    '487619',
                    '283656',
                    '392066',
                    '455987',
                    '165800',
                    '158266',
                    '167063',
                    '403919',
                    '425382',
                    '446691',
                    '450929',
                    '387403',
                    '330361',
                    '305634',
                    '388841',
                    '399263',
                    '212959',
                    '150899',
                    '98155',
                    '455239',
                    '157796',
                    '361274',
                ]
                const [, channelId] = location.href.match(/channel\/(\d+)/) || []

                const isWeChat = /MicroMessenger/.test(navigator.userAgent) && !/WindowsWechat/.test(navigator.userAgent)

                if (/channel\/\d+/.test(location.href)
                    && /channel_cps/.test(location.search)
                    && true /* (channelId && channelWhiteList.indexOf(channelId) >= 0) */ /* nsidWhiteList.indexOf(query.nsid) >= 0 */
                    && isWeChat) {
                    var id = (location.pathname.match(/\/channel2?\/(\d+)/) || [])[1]
                    var business_url = `${prodConfig.MAIN_URL}/channel/${id}/paysuccess` + location.search
                    var cancel_url = encodeURI(location.href)
                    axios
                        .get('/api/pay/wkpay', { params: Object.assign({}, query, params, { business_url, cancel_url }) })
                        .then((res) => {
                            var data = res.data
                            if (data.trade_platform === 'WKPAY') {
                                location.href = data.data.redirect_url
                            } else {
                                handler(res)
                            }
                        }).catch(normalPayProcess)
                } else {
                    normalPayProcess()
                }
            }
        }
    }

    render() {
        return <div>
            <Toast icon="loading" show={this.props.pay.status === 'paying'}>正在发起支付</Toast>
            <RepayQRCodeDialog ref="repay_dialog"/>
            <WKOwnDialog show={this.state.isShowRefundingDialog} type="ios"
                buttons={[{
                    label: '取消',
                    type: 'default',
                    onClick: () => this.setState({ isShowRefundingDialog: false })
                }, {
                    label: '查看订单',
                    onClick: () => location.assign(`/account/bought`)
                }]}
            >
                订单退款中，不可重复购买，可撤消退款后收听课程或退款成功后再购买
            </WKOwnDialog>
        </div>
    }
}

Pay.contextTypes = {
    page: React.PropTypes.object
};


export default connect(state => ({pay: state.pay}))(Pay)



// WEBPACK FOOTER //
// ./src/components/Pay.js